var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll"
    },
    [
      _c("div", { staticClass: "flex flex-wrap" }, [
        _c("div", { staticClass: "w-full p-3" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "overflow-y-auto" },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "px-5 py-2 " },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "flex flex-col mr-5",
                          attrs: { span: 6 }
                        },
                        [
                          _c("span", { staticClass: "text-left" }, [
                            _vm._v("Filter Date")
                          ]),
                          _vm._v(" "),
                          _c("vue-monthly-picker", {
                            attrs: {
                              monthLabels: _vm.monthLabels,
                              selectedBackgroundColor: "#1a202c",
                              clearOption: false,
                              max: _vm.maxMonth,
                              min: _vm.minMonth
                            },
                            on: { selected: _vm.onChangeDate },
                            model: {
                              value: _vm.selectedMonth,
                              callback: function($$v) {
                                _vm.selectedMonth = $$v
                              },
                              expression: "selectedMonth"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "flex flex-row mr-5",
                          attrs: { span: 3 }
                        },
                        [
                          _c("div", { staticClass: "bg-transparent w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card cursor-pointer border border-gray-400 rounded-lg"
                              },
                              [
                                _c("div", { staticClass: "m-3" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-xs text-center font-bold mb-2 border-b border-black mb-3"
                                    },
                                    [_vm._v("Paid Content")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-xl text-center text-black font-bold"
                                    },
                                    [_vm._v("$200")]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "flex flex-row mr-5",
                          attrs: { span: 3 }
                        },
                        [
                          _c("div", { staticClass: "bg-transparent w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card cursor-pointer border border-gray-400 rounded-lg"
                              },
                              [
                                _c("div", { staticClass: "m-3" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-xs text-center font-bold mb-2 border-b border-black mb-3"
                                    },
                                    [_vm._v("Paid Content")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-xl text-center text-black font-bold"
                                    },
                                    [_vm._v("$200")]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "flex flex-row mr-5",
                          attrs: { span: 3 }
                        },
                        [
                          _c("div", { staticClass: "bg-transparent w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card cursor-pointer border border-gray-400 rounded-lg"
                              },
                              [
                                _c("div", { staticClass: "m-3" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-xs text-center font-bold mb-2 border-b border-black mb-3"
                                    },
                                    [_vm._v("Paid Content")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-xl text-center text-black font-bold"
                                    },
                                    [_vm._v("$200")]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "flex flex-row mr-5",
                          attrs: { span: 3 }
                        },
                        [
                          _c("div", { staticClass: "bg-transparent w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card cursor-pointer border border-gray-400 rounded-lg"
                              },
                              [
                                _c("div", { staticClass: "m-3" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-xs text-center font-bold mb-2 border-b border-black mb-3"
                                    },
                                    [_vm._v("Paid Content")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-xl text-center text-black font-bold"
                                    },
                                    [_vm._v("$200")]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "flex flex-row mr-5",
                          attrs: { span: 3 }
                        },
                        [
                          _c("div", { staticClass: "bg-transparent w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card cursor-pointer border border-gray-400 rounded-lg"
                              },
                              [
                                _c("div", { staticClass: "m-3" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "text-xs text-center font-bold mb-2 border-b border-black mb-3"
                                    },
                                    [_vm._v("Paid Content")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-xl text-center text-black font-bold"
                                    },
                                    [_vm._v("$200")]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "data-tables-server",
                {
                  ref: "tableTransaction",
                  attrs: {
                    data: _vm.data,
                    total: _vm.total,
                    "pagination-props": {
                      background: true,
                      pageSizes: [_vm.displayingItem]
                    }
                  },
                  on: { "query-change": _vm.onChangeTable }
                },
                _vm._l(_vm.titles, function(title) {
                  return _c("el-table-column", {
                    key: title.prop,
                    attrs: {
                      prop: title.prop,
                      label: title.label,
                      sortable: "custom"
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
      },
      [
        _c("h5", { staticClass: "font-bold uppercase text-gray-600" }, [
          _vm._v("Revenue ")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c96bd4e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c96bd4e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RevenueList.vue
// module id = null
// module chunks = 